import React from 'react';

import { Select } from '@aline/common';
import { useParams } from 'react-router-dom';
import { Apollo } from 'src/gql/generated';
import { useCurrentUserQuery } from 'src/gql/hooks';

import { DoneSigningBody } from './DoneSigningBody';
import { SigningOutcomePage } from './SigningOutcomePage';

const ALL_SIGNED_STATES = [Apollo.WorkflowState.Signed, Apollo.WorkflowState.Complete];

export function WorkflowDoneSigning() {
  const { workflowId } = useParams<{ workflowId: UUID }>();
  const { data, loading } = Apollo.useGetWorkflowSigningStatusQuery({
    skip: !workflowId,
    variables: { workflowId: workflowId ?? '' },
  });
  const { currentUser } = useCurrentUserQuery();
  const isAllDoneSigning = ALL_SIGNED_STATES.some(state => state === data?.workflow?.state);
  const isInternalUser = currentUser?.loginType !== Apollo.LoginType.Passwordless;

  return (
    <SigningOutcomePage
      dataCy={Select.document.editor.walkthrough.doneSigningPage}
      showAboutAline={!isInternalUser}
      title="Done Signing"
    >
      <DoneSigningBody
        isAllDoneSigning={isAllDoneSigning}
        isInternalUser={isInternalUser}
        loading={loading}
        workflowId={workflowId}
      />
    </SigningOutcomePage>
  );
}
